// extracted by mini-css-extract-plugin
var _1 = "U7YWbul7";
var _2 = "T1B6fXNz";
var _3 = "T1B6fXNz";
export { _1 as "shrink", _2 as "toast-container", _3 as "toastContainer" }
